<template>
  <div>
    
    <div style="min-height:500px;"></div>
    <DownloadCell v-for="i in 0" :key="i.index"></DownloadCell>
  </div>
</template>

<script>
import DownloadCell from "@/components/AboutExamination/DownloadCell";
export default {
  components: {
    DownloadCell
  }
};
</script>
<style lang="less" scoped>
.cell-container {
}
</style>
